import { MutableRefObject, createContext } from 'react';

export interface PrintContextValue {
  contentRef: MutableRefObject<any>;
  onPrint(): void;
}

export const PrintContext = createContext<PrintContextValue | null>(null);

export const PrintModeContext = createContext<boolean>(false);
